function customerWeekOnload() {

    const topBar = document.getElementById('topBar');

    $(window).on('scroll', function () {
        const scroll = $(this).scrollTop();

        //paralax
        $('.ev_header_background').css(
            'transform',
            `translateY(${scroll * 0.3}px)`
        );

        // Progress bar
        const total = document.body.scrollHeight - window.innerHeight;
        const pct = (window.scrollY / total) * 100;
        topBar.style.width = pct + '%';

        //menu scroll
        if ($(this).scrollTop() > 400) {
            $('.header-scroll').addClass('show');
        } else {
            $('.header-scroll').removeClass('show');
        }
    });


    // Prazo final: 15/09/2026, 23h59 (horário de Brasília, UTC-3)
    var deadline = new Date("2026-09-15T23:59:00-03:00").getTime();
    var elD = document.getElementById("cd-d");
    var elH = document.getElementById("cd-h");
    var elM = document.getElementById("cd-m");
    var elS = document.getElementById("cd-s");
    function pad(n){ return String(n).padStart(2,"0"); }
    function tick(){
        var now = new Date().getTime();
        var diff = deadline - now;
        if (diff <= 0){
            elD.textContent = "0"; elH.textContent = "00"; elM.textContent = "00"; elS.textContent = "00";
            clearInterval(timer);
            return;
        }
        var d = Math.floor(diff / (1000*60*60*24));
        var h = Math.floor((diff % (1000*60*60*24)) / (1000*60*60));
        var m = Math.floor((diff % (1000*60*60)) / (1000*60));
        var s = Math.floor((diff % (1000*60)) / 1000);
        elD.textContent = d;
        elH.textContent = pad(h);
        elM.textContent = pad(m);
        elS.textContent = pad(s);
    }
    tick();
    var timer = setInterval(tick, 1000);

}